export default function MemberPriceIcon({ memberCornerMarkerText }: any) {
    return (
        <>
            <div className={`member-product-scene-item-price-member-box2`}>
                {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="member-product-scene-item-price-member-box2-icon member-product-scene-item-price-member-box2-icon-h5"
                    width="92"
                    height="18"
                    viewBox="0 0 92 18"
                    fill="none"
                >
                    <path d="M0.718083 8.76416L8.96458 0.76416H91.5V16.7642H8.96458L0.718083 8.76416Z" stroke="#FF7715" />
                </svg>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="105"
                    height="28"
                    viewBox="0 0 105 28"
                    fill="none"
                    className="member-product-scene-item-price-member-box2-icon member-product-scene-item-price-member-box2-icon-pc"
                >
                    <path d="M0.622233 14.1161L10.2519 1.11609H104.5V27.1161H10.2519L0.622233 14.1161Z" stroke="currentColor" />
                </svg> */}
                <div className="member-product-scene-item-price-member-box2-icon2">{memberCornerMarkerText}</div>
            </div>
        </>
    );
}
